(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nourish-curated-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nourish-curated-reviews')) {
  customElements.define('nourish-curated-reviews', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('.ncr-track');
      this.cards = Array.from(this.querySelectorAll('.ncr-card'));
      this.previous = this.querySelector('[data-direction="previous"]');
      this.next = this.querySelector('[data-direction="next"]');
      this.navigation = this.querySelector('.ncr-navigation');
      this.position = this.querySelector('.ncr-position');
      this.index = 0;
      if (!this.track || !this.cards.length) return;
      const update = () => {
        const left = this.track.getBoundingClientRect().left;
        this.index = this.cards.reduce((best, card, index) => Math.abs(card.getBoundingClientRect().left - left) < Math.abs(this.cards[best].getBoundingClientRect().left - left) ? index : best, 0);
        this.previous.disabled = this.index === 0;
        this.next.disabled = this.index === this.cards.length - 1;
        this.position.textContent = `${this.index + 1} of ${this.cards.length}`;
        this.navigation.hidden = this.cards.length < 2 || !window.matchMedia('(max-width:749px)').matches;
      };
      const move = index => {
        const target = Math.max(0, Math.min(index, this.cards.length - 1));
        this.track.scrollTo({left:this.cards[target].offsetLeft - this.cards[0].offsetLeft, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      this.previous.addEventListener('click', () => move(this.index - 1), {signal});
      this.next.addEventListener('click', () => move(this.index + 1), {signal});
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !window.matchMedia('(max-width:749px)').matches) return;
        const targets = {ArrowLeft:this.index - 1, ArrowRight:this.index + 1, Home:0, End:this.cards.length - 1};
        if (!(event.key in targets)) return;
        event.preventDefault();
        move(targets[event.key]);
      }, {signal});
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(update);
      }, {signal, passive:true});
      window.addEventListener('resize', update, {signal, passive:true});
      document.addEventListener('shopify:block:select', event => {
        const index = this.cards.findIndex(card => card.dataset.reviewBlock === event.detail.blockId);
        if (index >= 0 && window.matchMedia('(max-width:749px)').matches) move(index);
      }, {signal});
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
